export class Validator {
  public static isNumber(input: unknown): boolean {
    return typeof input === 'number' && !Number.isNaN(input);
  }

  public static isNumeric(input: unknown): boolean {
    return input !== null && (Validator.isNumber(input) || !Number.isNaN(Number(input)));
  }

  public static isString(input: unknown): input is string {
    return typeof input === 'string' || Object.prototype.toString.call(input) === '[object String]';
  }
  public static isNullOrWhitespace(input: unknown): boolean {
    return !input || !Validator.isString(input) || input.length === 0 || input.trim().length === 0;
  }

  public static isNonEmptyString(input: unknown): input is string {
    return !Validator.isNullOrWhitespace(input);
  }

  public static verifySwitchHandledAllOptions(violation: never): void {
    throw new Error(`Switch block failed to handle "${violation}"`);
  }
}
